function getQuantityInMinUnit(formatChosen, formats) {
  let equivalentQuantity = 1;
  let minUnitFound =
    formats[formatChosen]['cantidadSubUnidad'] === undefined ? true : false;

  while (!minUnitFound) {
    equivalentQuantity *= formats[formatChosen]['cantidadSubUnidad'];

    const nextSubFormat = formats[formatChosen]['subUnidad'];

    if (
      formats[nextSubFormat]['isFormatSaleMin'] !== undefined &&
      formats[nextSubFormat]['isFormatSaleMin'] === true
    ) {
      minUnitFound = true;
    } else {
      formatChosen = nextSubFormat;
    }
  }

  return equivalentQuantity;
}

export function getTotalCostOfBoughtFormats(formats_bought) {
  let tocalCost = 0;
  for (const [format, formatData] of Object.entries(formats_bought)) {
    tocalCost += formatData['quantityInCart'] * formatData['precio'];
  }

  return tocalCost;
}

export function getTotalMinUnitsBought(formats_bought, formats) {
  let total_min_units_bought = 0;
  for (const [format, formatData] of Object.entries(formats_bought)) {
    total_min_units_bought +=
      getQuantityInMinUnit(format, formats) * formatData['quantityInCart'];
  }
  return total_min_units_bought;
}
